import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

export const useSearchParam = (key: string): [string | null, (value: string | null) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get(key);

  const setValue = useCallback(
    (next: string | null) => {
      setSearchParams(
        prev => {
          const params = new URLSearchParams(prev);
          if (next) {
            params.set(key, next);
          } else {
            params.delete(key);
          }
          return params;
        },
        { replace: true }
      );
    },
    [setSearchParams, key]
  );

  return [value, setValue];
};
